import React from "react";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import About from "./components/About";
import Project from "./components/Project";
import Experience from "./components/Experience";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Slider from "./components/Certificates";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Project />
      <Slider />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
